import React from 'react';
import AdminLayout from '../../components/admin/AdminLayout';
import { DelegationsManagementPage } from '../shared/DelegationsManagementPage';

/**
 * Vista de auditoría de poderes firmados para superadmin.
 * Reutiliza la misma página de delegaciones (con descarga PDF).
 */
const AdminPowersPage: React.FC = () => {
  return (
    <AdminLayout>
      <DelegationsManagementPage mode="admin" focus="powers" />
    </AdminLayout>
  );
};

export default AdminPowersPage;
